import { render } from "./view-on-map.vue?vue&type=template&id=72af23b8"
import script from "./view-on-map.vue?vue&type=script&lang=js"
export * from "./view-on-map.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__